import { motion } from "framer-motion";

import Block3Columns from "../../components/Block3Columns";
import ImageContainer from "../../components/ImageContainer";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import MasonryGallery from "../../components/MasonryGallery";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import {
  BookOpen,
  Users,
  Globe,
  Lightbulb,
  Award,
  Search,
  TrendingUp,
  Heart,
  Download,
  Video,
  FileText,
  HelpCircle,
  Mail,
  Phone,
  ArrowRight,
  ChevronRight,
  MapPin,
  PartyPopper,
  Shirt,
  QrCode,
  GraduationCap,
} from "lucide-react";
import SubMenuDocentes from "../../components/posgrados/SubMenuDocentes";
import Accordion from "../../components/Accordion";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/c968a872-bae9-46d7-b961-cc6b0fa44d8c" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

function FormacionDocente() {
  const DataDisplay = ({ data }) => (
    <div>
      <ImageContainer
        src={data.imagen_portada}
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      >
        {" "}
      </ImageContainer>

      <div className="max-w-2xl m-auto text-center py-24 ">
        <div className="inline-flex items-center text-amber-500 gap-4">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <GraduationCap className="w-10 h-10 text-primary" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
          >
            <Globe className="w-10 h-10 text-primary" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1, ease: "easeOut" }}
          >
            <TrendingUp className="w-10 h-10 text-primary" />{" "}
          </motion.div>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque1,
          }}
        />
      </div>

      <div className=" py-24 bg-slate-50">
        <Block2ColumnsText
          col1={
            <div>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque2,
                }}
              />
            </div>
          }
          col2={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50  p-8 text-center">
              <div
                className="[&_p]:text-slate-600"
                dangerouslySetInnerHTML={{
                  __html: data.bloque3,
                }}
              />

              <div className="w-full mt-6">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-center">
                  <div className="p-4">
                    <div className="text-2xl font-montserrat font-bold text-[#febe10]">
                      7
                    </div>
                    <p className="text-slate-500 text-sm  text-center ">
                      Competencias Estratégicas
                    </p>
                  </div>
                  <div className="p-4 border-x border-slate-200">
                    <div className="text-2xl font-montserrat  font-bold text-[#febe10] ">
                      Impacto
                    </div>
                    <p className="text-slate-500 text-sm  text-center ">
                      Nacional e Internacional
                    </p>
                  </div>
                  <div className="p-4">
                    <div className="text-2xl font-montserrat  font-bold text-[#febe10] ">
                      Continua
                    </div>
                    <p className="text-slate-500 text-sm  text-center ">
                      Formación Permanente
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
        ></Block2ColumnsText>
      </div>
      {/* Competencias Section */}
      <section id="competencias" className="py-24  ">
        <div className="max-w-6xl mx-auto px-6">
          <div
            className="text-center w-[40%] m-auto mb-4 fontsize14"
            dangerouslySetInnerHTML={{
              __html: data.bloque4,
            }}
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <Heart size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque5,
                  }}
                />
              </div>{" "}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <Lightbulb size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </div>{" "}
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <Search size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </div>{" "}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <Globe size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque8,
                  }}
                />
              </div>{" "}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <TrendingUp size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque9,
                  }}
                />
              </div>{" "}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <Award size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque10,
                  }}
                />
              </div>{" "}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7, ease: "easeOut" }}
            >
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 text-blue-600">
                  <BookOpen size={24} />
                </div>
                <div
                  className=" mb-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque11,
                  }}
                />
              </div>{" "}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Programas de formación*/}
      <section id="programas" className="py-24 bg-slate-50 overflow-hidden">
        <motion.div
          className="max-w-6xl mx-auto px-6"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          {/* Título */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque12,
              }}
            />

      
          </motion.div>

          {/* Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-10">
            {/* Card 1 */}
            <motion.div
              className="bg-slate-50 overflow-hidden rounded-2xl border border-slate-200 shadow-sm hover:shadow-2xl transition-all"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img
                className="w-full h-64 object-cover"
                src={data.imagen13}
              ></img>
              <div className="p-4">
                <motion.div className="bg-blue-500 text-white px-6 py-1 text-xs mb-2 rounded-2xl max-w-max">
                  Fundamental
                </motion.div>

                <div
                  className="link-with-arrow-1"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque13,
                  }}
                />
                      <Accordion
              title="Cursos anteriores"
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque15,
                    }}
                  />
                </>
              }
            ></Accordion>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div
              className="bg-slate-50 overflow-hidden rounded-2xl border border-slate-200 shadow-sm hover:shadow-2xl transition-all"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              {" "}
              <img
                className="w-full h-64 object-cover"
                src={data.imagen14}
              ></img>
              <div className="p-4">
                <motion.div className="bg-blue-500 text-white px-6 py-1 text-xs mb-2 rounded-2xl max-w-max">
                  Disciplinares
                </motion.div>
                <div
                  className="link-with-arrow-1"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque14,
                  }}
                />
              </div>
            </motion.div>
          </div>
        </motion.div>
      </section>
      {/* Docentes en territorio*/}
      <section
        id="territorio"
        className="py-20  bg-[#004270] overflow-hidden relative"
      >
        <div className="max-w-6xl mx-auto px-6 ">
          <div className="flex flex-col lg:flex-row gap-16 items-center">
            <div className="flex-1 min-w-0">
              <div
                className="[&_p]:text-white [&_h2]:text-white mb-10"
                dangerouslySetInnerHTML={{
                  __html: data.bloque16,
                }}
              />

              <div className="flex-1 w-full min-w-0">
                <div className="bg-white/5 p-4 rounded-3xl border border-white/10 shadow-2xl overflow-hidden backdrop-blur-sm">
                  <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-inner">
                    <iframe
                      className="absolute top-0 left-0 w-full h-full"
                      src="https://www.youtube.com/embed/ly9IZu_2mWw"
                      title="Docentes en Territorio: Transformando vidas y contextos"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="bg-white text-slate-900 p-8 rounded-3xl shadow-2xl hover:shadow-lg ">
                <div className="text-xl font-bold ">
                  <Award className="text-[#004270]" />
                </div>
                <div className="space-y-6 ">
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: data.bloque19,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Labor tutorial*/}

      <section id="labor" className="py-24   max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
          <div
            className="[&_h2]:font-bold"
            dangerouslySetInnerHTML={{
              __html: data.bloque29,
            }}
          />
          <div
            className="text-center m-auto"
            dangerouslySetInnerHTML={{
              __html: data.bloque30,
            }}
          />
        </div>
      </section>

      {/* Recursos Section */}
      <section id="recursos" className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 ">
          <div
            className="pb-10"
            dangerouslySetInnerHTML={{
              __html: data.bloque20,
            }}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl border border-slate-200 hover:border-blue-400 transition-colors">
              <FileText className="text-[#004270]  " />
              <div
                className="mt-5   [&_h4]:font-bold  "
                dangerouslySetInnerHTML={{
                  __html: data.bloque21,
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 hover:border-blue-400 transition-colors">
              <Award className="text-[#004270]  " />

              <div
                className="mt-5   [&_h4]:font-bold  "
                dangerouslySetInnerHTML={{
                  __html: data.bloque22,
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 hover:border-blue-400 transition-colors">
              <HelpCircle className="text-[#004270]  " />

              <div
                className="mt-5   [&_h4]:font-bold  "
                dangerouslySetInnerHTML={{
                  __html: data.bloque23,
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 hover:border-blue-400 transition-colors">
              <Search className="text-[#004270]  " />
              <div
                className="mt-5   [&_h4]:font-bold  "
                dangerouslySetInnerHTML={{
                  __html: data.bloque24,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* RESULTADOS */}
      <section id="heteroevaluacion" className="py-24">
        <div>
          <div className="max-w-6xl mx-auto px-6 link-with-arrow-1">
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque26,
              }}
            />

            <Accordion
              title="Resultados anteriores"
              content={
                <>
                  <div>
                    <div
                      className="mt-5   [&_h2]:font-bold "
                      dangerouslySetInnerHTML={{
                        __html: data.bloque27,
                      }}
                    />
                    <div
                      className="mt-5  [&_h2]:font-bold "
                      dangerouslySetInnerHTML={{
                        __html: data.bloque28,
                      }}
                    />
                  </div>
                </>
              }
            ></Accordion>
          </div>{" "}
        </div>
      </section>
    </div>
  );

  return (
    <>
      <SubMenuDocentes></SubMenuDocentes>
      <DataFetcherTemplateHome2 url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome2>{" "}
    </>
  );
}

export default FormacionDocente;
